import {
  Box,
  Button as MuiButton,
  Stack,
  Typography,
} from "@mui/material";

import "./ActivityCard.css";
import monthmap from "../utils/monthmap.js";
import {
  compareTimestamps as timestampdifference,
} from "../utils/timestampdifference";

const ActivityTimestamp = (props) => {
  return (() => {
    const startTimestamp = props ? new Date(props.activityStart) : null;
    const endTimestamp = props ? new Date(props.activityEnd) : null;
    var start = { sDay: 0, sMonth: 0, sHour: 0, sMinute: 0 };
    var end = { eDay: 0, eMonth: 0, eHour: 0, eMinute: 0 };

    if (startTimestamp) {
      start = {
        sDay: startTimestamp.getDate(),
        sMonth: startTimestamp.getMonth(),
        sHour: String(startTimestamp.getHours()).padStart(2, "0"),
        sMinute: String(startTimestamp.getMinutes()).padStart(2, "0"),
      };
    }
    if (endTimestamp) {
      end = {
        eDay: endTimestamp.getDate(),
        eMonth: endTimestamp.getMonth(),
        eHour: String(endTimestamp.getHours()).padStart(2, "0"),
        eMinute: String(endTimestamp.getMinutes()).padStart(2, "0"),
      };
    }

    const { sDay, sMonth, sHour, sMinute } = start;
    const { eDay, eMonth, eHour, eMinute } = end;

    return (
      <Stack mb={props.card ? 2 : 4}>
        {/** Activity Start */}
        <Box mb={1}>
          <Typography variant={props.card ? "body2" : "body1"} fontWeight={700}>
            Activity Start
          </Typography>
        </Box>

        <Stack
          direction="row"
          spacing={1}
          justifyContent="space-between"
          alignItems="center"
          mb={1}
        >
          <Box
            sx={{
              width: props.card ? 32 * 6 : "50%",
              border: "solid 2px #2D9CDB",
              borderRadius: 2,
              p: 1,
            }}
          >
            <Stack
              sx={{ margin: "0 auto" }}
              justifyContent="center"
              spacing={1}
              direction="row"
            >
              <Typography>
                <strong>{sDay}</strong>
              </Typography>
              <Typography sx={{ alignSelf: "end" }} variant="caption">
                {monthmap[sMonth]}
              </Typography>
            </Stack>
          </Box>

          <Stack
            direction="row"
            alignItems="end"
            spacing={1}
            sx={{
              width: props.card ? "100%" : "50%",
              border: "solid 2px #dff0fa",
              background: "#dff0fa",
              borderRadius: 2,
              p: 1,
            }}
          >
            <Typography>
              <strong>{`${sHour}:${sMinute}`}</strong>
            </Typography>
            <Typography variant="caption">
              {timestampdifference(new Date(), startTimestamp).split("ago")
                .length < 2 && timestampdifference(new Date(), startTimestamp)}
            </Typography>
          </Stack>
        </Stack>

        {/** Activity End */}
        <Box mb={1}>
          <Typography variant={props.card ? "body2" : "body1"} fontWeight={700}>
            Activity End
          </Typography>
        </Box>

        <Stack
          direction="row"
          spacing={1}
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            sx={{
              width: props.card ? 32 * 6 : "50%",
              border: "solid 2px #2D9CDB",
              borderRadius: 2,
              p: 1,
            }}
          >
            <Stack
              sx={{ margin: "0 auto" }}
              justifyContent="center"
              spacing={1}
              direction="row"
            >
              <Typography>
                <strong>{eDay}</strong>
              </Typography>
              <Typography sx={{ alignSelf: "end" }} variant="caption">
                {monthmap[eMonth]}
              </Typography>
            </Stack>
          </Box>

          <Stack
            direction="row"
            alignItems="end"
            spacing={1}
            sx={{
              width: props.card ? "100%" : "50%",
              border: "solid 2px #dff0fa",
              background: "#dff0fa",
              borderRadius: 2,
              p: 1,
            }}
          >
            <Typography>
              <strong>{`${eHour}:${eMinute}`}</strong>
            </Typography>
            <Typography variant="caption">
              {timestampdifference(new Date(), startTimestamp).split("ago")
                .length >= 2 && timestampdifference(new Date(), startTimestamp)}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    );
  })();
};

export default ActivityTimestamp;